import { useEffect } from 'react';

import { setPersistedLocale } from '../persistedLocale';

import { useCurrentLocale } from './selectors';

export const usePersistLocale = () => {
  const locale = useCurrentLocale();

  useEffect(() => {
    setPersistedLocale(locale);
  }, [locale]);
};
